<template>
  <div style="height: 80vh;">
    <!-- <div v-if="isDev">
      <div>isMasterSectionState: {{ isMasterSectionState }}</div>
      <div>type: {{ type }}</div>
    </div> -->

    <AntRow>
      <AntCol
        v-if="isMasterSectionState"
        :span="5"
        class="apply-docs-col"
      >
          <AntInputSearch
            v-model:value="searchValue"
            style="margin-bottom: 16px"
            placeholder="Search"
          />
          <AntTree
            blockNode
            :selectedKeys="selectedKeys"
            :treeData="displayedTreeData"
            :fieldNames="{ key: 'docId' }"
            @select="onSelect"
          >
            <template #title="{ docId, docData }">
              <AntTag
                :color="docId.includes('master') ? 'orange' : (isDocCustomized(docId) ? 'green' : 'blue')"
                style="width: 75px;text-align: center;"
              >
                {{ docId.includes('master') ? '母本' : (isDocCustomized(docId) ? 'Customized' : 'General') }}
              </AntTag>
              {{ docData.docShortTitle }}
            </template>
          </AntTree>
      </AntCol>

      <AntCol
        :span="isMasterSectionState ? 19 : 24"
        class="apply-docs-col preview-col"
      >
          <div
            v-show="!selectedKeys[0].includes('master') && selectedSectionState.sectionId !== 'ReleaseVer'"
            class="preview-header"
          >
            <DocPlatformInfo
              :key="platformInfoResetKey"
              collapsible
              :bordered="false"
              :docData="previewedState.docData"
              :sectionPlatforms="previewedState.platforms"
              :sectionExcludedPlatforms="previewedState.excludedPlatforms"
              :showSectionPlatforms="true"
              :platformsMap="platformsMap"
              :hideUnknownPlatforms="!isDev"
            />
          </div>

          <div class="preview-body">
            <div v-show="false" id="viewer" />
            <div v-if="previewedState.deleted">
              因子本 Platforms / Excluded Platforms 與此區塊 Platforms 的設定，前台 API 文件將不顯示此區塊
            </div>
            <div v-else class="mock-redoc">
            <section class="content">
              <h2>{{ previewedState.enTitle }} {{ previewedState.cnTitle }}</h2>
              <div class="section-editor viewer" v-html="contentHtml" />
              <div class="section-editor viewer" v-html="restrictedContentHtml" />
              <div class="section-editor viewer" v-html="tableDataHtml" style="margin-bottom: 30px" />

              <div v-if="previewedState.sectionType === 'api'" class="api-content">
                <h5>header Parameters</h5>
                <table>
                  <tbody>
                    <tr>
                      <td class="field-name only">
                        <span class="line" />
                        <span>Content-Type</span>
                        <div class="required">required</div>
                      </td>
                      <td class="field-content">
                        <div>
                          <div><span class="field-type">string</span></div>
                          <div><span> Example: </span> <code>application/x-www-form-urlencoded</code></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div v-for="scope in ['request', 'response']" :key="scope">
                  <template v-if="scope === 'response'">
                    <h3>Responses</h3>
                    <button class="status-code-btn"><ArrowDownIcon /> 200</button>
                  </template>
                  <h5>
                    {{ scope }} schema:
                    <span v-if="scope === 'request'">application/x-www-form-urlencoded</span>
                    <span v-else>application/json;charset=UTF-8</span>
                  </h5>
                  <div v-html="renderFieldTableHtml(scope)" />
                </div>
              </div>
            </section>
            <section v-if="previewedState.sectionType === 'api' && selectedExampleId" class="examples">
              <button>
                <span class="method">post</span>
                <span class="path">{{ previewedState.path }}</span>
                <ArrowDownIcon />
              </button>
              <div v-for="scope in ['request', 'response']" :key="scope">
                <div v-if="checkFieldsHasExampleValue(scope, getScopeRootFields(scope))">
                  <h3>{{ titleCase(scope) }} samples</h3>
                  <div class="example">
                    <div class="example-input">
                      <div class="example-input-label">Content type</div>
                      <div>
                        {{ scope === 'request' ? 'application/x-www-form-urlencoded' : 'application/json;charset=UTF-8' }}
                      </div>
                    </div>
                    <div class="example-input">
                      <div class="example-input-label">Example</div>
                      <div class="example-dropdown-trigger" @click="toggleExampleDropdown">
                        {{ previewedState.examples[selectedExampleId]?.exampleName }}
                        <CaretDownIcon />
                      </div>
                      <div class="example-dropdown" v-show="isExampleDropdownVisible">
                        <div
                          v-for="example in getSortedExamples(previewedState.examples)"
                          :key="example.exampleId"
                          class="example-dropdown-option"
                          @click="handleSelectExample(example.exampleId)"
                        >
                          {{ example.exampleName }}
                        </div>
                      </div>
                    </div>
                    <code v-if="getScopeRootFields(scope).length">
                      <div v-text="`{`" />
                      <div
                        v-for="field in getScopeRootFields(scope)"
                        :key="field.fieldId"
                        class="example-field"
                        v-html="renderExampleHtml(scope, field)"
                      />
                      <div v-text="`}`" />
                    </code>
                  </div>
                </div>
              </div>
            </section>
            </div>
          </div>
        </AntCol>
    </AntRow>

    <div v-if="isDev">
      <div><b>selectedExampleId:</b> {{ selectedExampleId }}</div>
      <!-- <div>searchValue: {{searchValue}}</div> -->
      <div><b>selectedKeys:</b> {{ selectedKeys }}</div>
      <!-- <div><b>appliedDocsWithSortOrderOrDeleted:</b> {{ appliedDocsWithSortOrderOrDeleted }}</div> -->
      <div style="display: flex;">
        <DevDebugDataBlock title="selectedSectionState" :data="selectedSectionState" width="50%" maxHeight="200px" />
        <DevDebugDataBlock title="previewedState" :data="previewedState" width="50%" maxHeight="200px" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-case-declarations, no-nested-ternary */
import {
  ref,
  inject,
  watch,
  reactive,
  computed,
  onMounted,
  onUnmounted,
  nextTick,
} from 'vue'

import { isEmpty } from 'lodash'

import {
  Row as AntRow,
  Col as AntCol,
  Tree as AntTree,
  Input as AntInput,
  Tag as AntTag,
} from 'ant-design-vue'

import ArrowDownIcon from '@ant-design/icons-vue/lib/icons/DownOutlined'
import CaretDownIcon from '@ant-design/icons-vue/lib/icons/CaretDownOutlined'

import DocPlatformInfo from '@/components/ApiDoc/doc/DocPlatformInfo.vue'
import DevDebugDataBlock from '@/components/ApiDoc/shared/DevDebugDataBlock.vue'

import { titleCase, emptyObject } from '@/utils'
import { isRootParentSectionId } from '../lib/constants'
import { useViewerEditor, contentToHtml } from '../shared/viewerEditor'

import {
  sortDocIds,
  renderTableDataByPlatformHtml,
  renderStringifiedJsonTableRowArray,
  buildStringifiedJsonTableHtml,
  processContentBrand as processBrand,
  shouldDisplay,
  compareExampleSortKeys,
  buildDocSectionTree,
  buildSectionsBySectionIdForDoc,
} from '../lib/libsV3'

export default {
  name: 'ApplyDocs',
  components: {
    AntRow,
    AntCol,
    AntTree,
    AntInputSearch: AntInput.Search,
    AntTag,
    ArrowDownIcon,
    CaretDownIcon,
    DocPlatformInfo,
    DevDebugDataBlock,
  },
  props: {
    visible: Boolean,
    selectedSectionState: Object,
    selectedFieldState: Object,
    sectionsBySectionId: Object,
    sectionsDataByDocId: Object,
    docsDataByDocId: Object,
    templateDataByTemplateId: Object,
    entirePlatformOptions: Array,
  },
  setup(props) {
    const API_SCOPES = ['request', 'response']
    const COMPLEX_FIELD_TYPES = ['array of objects', 'object']
    const STRING_ARRAY_TYPES = ['array of strings', 'array of numbers']

    const isDev = inject('isDev')
    const isMasterSectionState = computed(() => props.selectedSectionState.docId.includes('master'))

    const searchValue = ref('')
    const platformInfoResetKey = ref(0)

    const masterDocId = computed(() => `${props.selectedSectionState.wallet || 'multi'}#master`)

    const getMasterDocData = () => {
      const docId = masterDocId.value
      const wallet = props.selectedSectionState.wallet || 'multi'
      return props.docsDataByDocId[docId] || {
        docId,
        wallet,
        docTitle: `${titleCase(wallet)} Wallet`,
        docShortTitle: `${titleCase(wallet)} Wallet`,
      }
    }

    const getDocDataForPreview = docId => (docId.includes('master') ? getMasterDocData() : props.docsDataByDocId[docId])

    const previewDocIds = computed(() => {
      if (props.selectedSectionState.sectionId === 'ReleaseVer') {
        return [props.selectedSectionState.docId]
      }
      const masterId = masterDocId.value
      return [masterId, ...sortDocIds(props.selectedSectionState.docs || []).filter(id => id !== masterId)]
    })

    const selectedKeys = ref([previewDocIds.value[0]])

    const apiSectionsByDocId = computed(() => previewDocIds.value.reduce((acc, docId) => {
      const sections = props.sectionsDataByDocId?.[docId] || []
      acc[docId] = sections
        .filter(({ parentSectionId, tag, wallet }) => {
          if (isRootParentSectionId(parentSectionId)) return false
          if (wallet === 'single') return tag === 'common-api-functions'
          if (wallet === 'multi') return tag === 'common-api-functions' || tag === 'multi-wallet-api-functions'
          return false
        })
        .sort((a, b) => a.sortOrder - b.sortOrder)
      return acc
    }, {}))

    // 與 SectionTree 子本 tab 相同結構的 treeData（頂層 section 節點）
    const getDocSectionTreeData = docId => buildDocSectionTree(docId, props.sectionsDataByDocId)

    // 含 treeTitle 等欄位，供 processContentLink / 表格內連結解析
    const getSectionsBySectionIdForDoc = (docId) => {
      if (!docId || !props.sectionsDataByDocId?.[docId]) {
        return props.sectionsBySectionId || {}
      }
      return buildSectionsBySectionIdForDoc(docId, props.sectionsDataByDocId)
    }

    useViewerEditor()

    const isDocCustomized = (docId) => {
      if (props.selectedSectionState.customizedVersion?.[docId]) {
        const {
          docId: customizedDocId, sectionId, sortOrder, ...rest
        } = props.selectedSectionState.customizedVersion?.[docId]
        if (!isEmpty(rest)) return true
      }

      return Object.values(props.selectedFieldState).some(scope => Object.values(scope).some(field => field.customizedVersion?.[docId]))
    }

    const buildPreviewStateByDocId = (docId) => {
      const docData = getDocDataForPreview(docId)
      const customizedFieldState = {}
      Object.entries(props.selectedFieldState).forEach(([scope, scopeData]) => {
        customizedFieldState[scope] = {}
        Object.values(scopeData).forEach((field) => {
          if (field.deleted || !shouldDisplay(field, docData)) return

          const {
            customizedVersion: {
              [docId]: { examples, ...restCustomizedVersion } = {},
            } = {},
          } = field
          console.log('buildPreviewStateByDocId', docId, examples)
          customizedFieldState[scope][field.fieldId] = {
            ...field,
            ...restCustomizedVersion,
          }
        })
      })
      console.log('buildPreviewStateByDocId customizedFieldState', docId, customizedFieldState)

      const {
        customizedVersion: {
          [docId]: { examples, ...restCustomizedVersion } = {},
        } = {},
      } = props.selectedSectionState
      return {
        ...props.selectedSectionState,
        ...restCustomizedVersion,
        ...customizedFieldState,
        docId,
        docData,
      }
    }

    const buildTreeData = () => previewDocIds.value.map((docId) => {
      const isMasterDoc = docId.includes('master')
      const docData = getDocDataForPreview(docId)
      return {
        ...(!isMasterDoc && !shouldDisplay(props.selectedSectionState, docData) ? { deleted: true } : {}),
        ...buildPreviewStateByDocId(docId),
      }
    })

    const treeData = ref(buildTreeData())

    const displayedTreeData = ref(treeData.value)

    const previewedState = reactive({})
    const selectedExampleId = ref('')

    const getSortedExamples = (examples = {}) => {
      const examplesArr = Object.values(examples)
        .filter((example) => {
          console.log('getSortedExamples example', previewedState.docId, example.exampleName, example, shouldDisplay(example, props.docsDataByDocId[previewedState.docId]))
          return shouldDisplay(example, props.docsDataByDocId[previewedState.docId])
        })
      return examplesArr.sort((a, b) => compareExampleSortKeys(a.exampleName, b.exampleName))
    }

    const platformsMap = computed(() => Object.fromEntries(props.entirePlatformOptions.map(p => [p.value, p.label])))

    const contentHtml = ref('')
    const restrictedContentHtml = ref('')
    const tableDataHtml = ref('')

    const fieldContentHtmls = ref({})

    const processContentBrand = (content = '') => {
      if (!content || previewedState.docId.includes('master')) return content

      const { templateId } = props.docsDataByDocId[previewedState.docId]
      const templateData = props.templateDataByTemplateId[templateId]
      if (!templateData) return content

      const { brandText } = templateData
      return processBrand(content, brandText)
    }

    const getScopeFields = scope => previewedState[scope] || {}

    const getSortedFieldsByParent = (scope, parentFieldId = 'ROOT') => Object.values(getScopeFields(scope))
      .filter(field => (field.parentFieldId || 'ROOT') === parentFieldId)
      .sort((a, b) => {
        const sortOrderDiff = (a.sortOrder ?? Number.MAX_SAFE_INTEGER) - (b.sortOrder ?? Number.MAX_SAFE_INTEGER)
        if (sortOrderDiff !== 0) return sortOrderDiff
        return (a.fieldName || '').localeCompare(b.fieldName || '')
      })

    const getScopeRootFields = scope => getSortedFieldsByParent(scope, 'ROOT')
    const getChildFields = (scope, fieldId) => getSortedFieldsByParent(scope, fieldId)
    const getFieldContentKey = (scope, fieldId) => `${scope}-${fieldId}`

    const computeFieldContentHtmls = async () => {
      const tasks = API_SCOPES.flatMap((scope) => {
        const fields = Object.values(getScopeFields(scope))
        return fields.map((field) => {
          if (!field?.content) return null
          return async () => {
            fieldContentHtmls.value[getFieldContentKey(scope, field.fieldId)] = processContentBrand(await contentToHtml(field.content))
          }
        })
      })
      await Promise.all(tasks.filter(Boolean).map(task => task()))
    }

    const computeHtml = async () => {
      console.log('computeHtml previewedState', previewedState)

      fieldContentHtmls.value = {}
      await computeFieldContentHtmls()

      contentHtml.value = processContentBrand(await contentToHtml(previewedState.content))
      restrictedContentHtml.value = shouldDisplay(previewedState.restricted, props.docsDataByDocId[previewedState.docId])
        ? processContentBrand(await contentToHtml(previewedState.restricted?.content))
        : ''

      console.log('apiSectionsByDocId.value', apiSectionsByDocId.value)

      if (!previewedState.tableColumns) {
        tableDataHtml.value = ''
        return
      }

      let idLabelMap = platformsMap.value
      if (previewedState.tag === 'request-time-interval-limits') {
        idLabelMap = apiSectionsByDocId.value[previewedState.docId].reduce((acc, section) => {
          if (section.sectionType === 'api') acc[section.operationId] = true
          return acc
        }, {})
      } else if (previewedState.tag === 'platforms-regional-ip-restriction') {
        idLabelMap['{{brand}}'] = '{{brand}}'
        if (!previewedState.docId.includes('master')) idLabelMap['{{brand}}'] = props.templateDataByTemplateId[props.docsDataByDocId[previewedState.docId].templateId]?.brandText
      }

      tableDataHtml.value = renderTableDataByPlatformHtml({
        tableData: {
          columns: previewedState.tableColumns,
          platformsOrder: previewedState.tablePlatformsOrder,
          rowData: Object.values(previewedState.row).sort((a, b) => a.sortOrder - b.sortOrder),
        },
        idLabelMap,
        sectionsBySectionId: getSectionsBySectionIdForDoc(previewedState.docId),
        brandText: previewedState.docId.includes('master') ? '' : props.templateDataByTemplateId[props.docsDataByDocId[previewedState.docId].templateId]?.brandText,
        docData: props.docsDataByDocId[previewedState.docId],
      })
    }

    const handleDisableLinkClick = (e) => {
      console.log('handleDisableLinkClick', e.target)
      e.preventDefault()
    }

    const attachLinkClickHandlers = () => {
      document
        .querySelectorAll('.section-editor.viewer a')
        .forEach(el => el.addEventListener('click', handleDisableLinkClick))
    }

    const detachLinkClickHandlers = () => {
      document
        .querySelectorAll('.section-editor.viewer a')
        .forEach(el => el.removeEventListener('click', handleDisableLinkClick))
    }

    const initPreviewFromProps = async () => {
      platformInfoResetKey.value += 1
      searchValue.value = ''
      treeData.value = buildTreeData()
      displayedTreeData.value = treeData.value
      selectedKeys.value = [previewDocIds.value[0]]
      emptyObject(previewedState)
      Object.assign(previewedState, treeData.value[0] || {})
      selectedExampleId.value = getSortedExamples(previewedState.examples)[0]?.exampleId
      await computeHtml()
      detachLinkClickHandlers()
      nextTick(attachLinkClickHandlers)
    }

    watch(() => props.visible, (visible) => {
      if (visible) initPreviewFromProps()
    })

    onMounted(() => {
      if (props.visible) initPreviewFromProps()
    })

    onUnmounted(detachLinkClickHandlers)

    watch(searchValue, (value) => {
      const keyword = value.toLowerCase()
      displayedTreeData.value = treeData.value.filter(({ docData = {} }) => (
        (docData.docShortTitle || docData.docTitle || '').toLowerCase().includes(keyword)
      ))
    })

    const onSelect = async (keys, { node }) => {
      if (!keys?.length) return
      const nodeData = node?.dataRef ?? treeData.value.find(({ docId }) => docId === keys[0])
      if (!nodeData) return
      console.log('[ApplyDocs] onSelect selectedKeys', keys, nodeData)
      selectedKeys.value = keys
      emptyObject(previewedState)
      Object.assign(previewedState, nodeData)
      selectedExampleId.value = getSortedExamples(previewedState.examples)[0]?.exampleId
      await computeHtml()
    }

    const renderStringifiedJsonTableHtml = (scope, fieldData) => buildStringifiedJsonTableHtml({
      rows: renderStringifiedJsonTableRowArray({
        parentFieldId: fieldData.fieldId,
        scopeFields: getScopeFields(scope),
        docData: props.docsDataByDocId[previewedState.docId],
      }),
      tableClassName: 'stringified-json-table',
      getDescriptionHtml: (childField) => {
        const html = fieldContentHtmls.value[getFieldContentKey(scope, childField.fieldId)]
        if (html) return `<div class="section-editor viewer">${html}</div>`
        if (childField.content) return `<div class="section-editor viewer">${childField.content}</div>`
        return ''
      },
    })

    const renderTrHtml = (scope, fields) => {
      let trHtml = ''

      fields.forEach((field, fieldIndex) => {
        // console.log('renderTrHtml', selectedKeys.value[0], field.fieldName, shouldDisplay(field, props.docsDataByDocId[previewedState.docId]))
        if (!shouldDisplay(field, props.docsDataByDocId[previewedState.docId])) return

        const children = getChildFields(scope, field.fieldId)
        const isOnly = fields.length === 1

        trHtml += `
          <tr${fields.length - 1 === fieldIndex ? ' class="last"' : ''}>
            <td class="field-name${isOnly ? ' only' : ''}">
              <span class="line"></span>
              <span>${field.fieldName}</span>
              ${field.required ? '<div class="required">required</div>' : ''}
            </td>
            <td class="field-content${COMPLEX_FIELD_TYPES.includes(field.fieldType) ? ' has-nested' : ''}">
              <div>
                <div class="field-type">
                  <span>
                    ${field.fieldType === 'stringified json' ? 'string' : field.fieldType}
                    ${field.numberType ? `<${field.numberType}>` : ''}
                  </span>
                  ${field.maxLength ? `<code><= ${field.maxLength} characters</code>` : ''}
                  ${field.decimalPlace ? `<code>decimal places <= ${field.decimalPlace}</code>` : ''}
                </div>

                ${fieldContentHtmls.value[getFieldContentKey(scope, field.fieldId)] ? `<div class="section-editor viewer">
                  ${fieldContentHtmls.value[getFieldContentKey(scope, field.fieldId)]}
                </div>` : ''}

                ${field.fieldType === 'stringified json' ? renderStringifiedJsonTableHtml(scope, field) : ''}
              </div>
            </td>
          </tr>
        `
        if (COMPLEX_FIELD_TYPES.includes(field.fieldType) && children.length) {
          trHtml += `<tr><td colspan="2">${renderNestedTableHtml(scope, field)}</td></tr>` // eslint-disable-line no-use-before-define
        }
      })

      return trHtml
    }

    const renderNestedTableHtml = (scope, fieldData) => {
      const { fieldId, fieldType } = fieldData
      const trHtml = renderTrHtml(scope, getChildFields(scope, fieldId))
      return `
        <div class="nested-table-wrapper">
          ${fieldType === 'array of objects' ? 'Array [' : ''}
          <table>
            <tbody>${trHtml}</tbody>
          </table>
          ${fieldType === 'array of objects' ? ']' : ''}
        </div>
      `
    }

    const renderFieldTableHtml = (scope) => {
      const trHtml = renderTrHtml(scope, getScopeRootFields(scope))
      return `
        <table>
          <tbody>${trHtml}</tbody>
        </table>
      `
    }

    const renderExampleValue = (scope, fieldData, arrayIdx, renderJson = false) => {
      const { fieldType } = fieldData
      let exampleText = ''
      let exampleValue = fieldData.examples?.[selectedExampleId.value]
      if (arrayIdx != null) exampleValue = exampleValue[arrayIdx]

      switch (fieldType) {
        case 'number':
          if (exampleValue) exampleText = Number(exampleValue)
          break

        case 'boolean':
          if (exampleValue) exampleText = exampleValue.toLowerCase() === 'true' ? 'true' : 'false'
          break

        case 'stringified json':
          let json
          const stringifiedJsonChildren = getChildFields(scope, fieldData.fieldId)
          if (!stringifiedJsonChildren.length) return ''

          stringifiedJsonChildren.forEach((childFieldData) => {
            const childExampleValue = renderExampleValue(scope, childFieldData, undefined, true)
            if (childExampleValue != null) {
              if (!json) json = {}
              json[childFieldData.fieldName] = childExampleValue
            }
          })
          console.log('parse stringified json', json)
          if (json) exampleText = `"${JSON.stringify(json).replaceAll('"', '\\"')}"`

          break

        case 'json': // gameInfo
          if (exampleValue) {
            try {
              exampleText = JSON.parse(exampleValue)
            } catch (e) {
              exampleText = exampleValue
            }
          }
          break

        case 'array of objects':
          const arrayChildren = getChildFields(scope, fieldData.fieldId)
          if (!arrayChildren.length) return ''

          const arrayOfObjs = []
          arrayChildren.forEach((childFieldData) => {
            const { arrayLength } = fieldData.examples?.[selectedExampleId.value] || {}

            Array.from({ length: arrayLength || 1 }).forEach((_, idx) => {
              let childExampleValue = renderExampleValue(scope, childFieldData, undefined, true)
              childExampleValue = arrayLength ? childExampleValue[idx] : childExampleValue
              console.log(idx, '******childExampleValue', childFieldData.fieldName, childExampleValue)
              if (childExampleValue != null && childExampleValue !== '') {
                if (!arrayOfObjs[idx]) arrayOfObjs[idx] = {}

                if (childExampleValue === '""') {
                  childExampleValue = ''
                } else if (childExampleValue === 'null') {
                  childExampleValue = null
                }

                arrayOfObjs[idx][childFieldData.fieldName] = childExampleValue
              }
            })
          })
          console.log('arrayOfObjs', arrayOfObjs)
          if (arrayOfObjs.length) {
            exampleText = renderJson ? arrayOfObjs : JSON.stringify(arrayOfObjs).replaceAll('"', '\\"')
          }

          break

        case 'array of strings':
          if (exampleValue) {
            if (/^\[\s*\]$/.test(exampleValue)) {
              exampleText = []
            } else {
              const cleanedStr = exampleValue.replace(/\[|\]/g, '') // 移除頭尾的方括號
                .split(',')
                .map(s => s.trim().replace(/^"(.*)"$/, '$1')) // 去除多餘的空格 & 移除已經有的雙引號
                .map(s => (s.includes('"') ? s : `"${s}"`)) // 如果沒有雙引號，則加上雙引號
                .join(',')
              exampleText = JSON.parse(`[${cleanedStr}]`)
            }
          }
          break

        case 'array of numbers':
          if (exampleValue) {
            if (/^\[\s*\]$/.test(exampleValue)) {
              exampleText = []
            } else {
              exampleText = JSON.parse(exampleValue)
            }
          }
          break

        case 'string':
          if (exampleValue) {
            if (exampleValue === 'null') {
              exampleText = exampleValue
            } else if (exampleValue === '\'\'' || exampleValue === '""') {
              exampleText = '""'
            } else {
              try {
                if (!Number.isNaN(Number(exampleValue))) {
                  exampleText = renderJson ? exampleValue : `"${exampleValue}"`
                } else {
                  exampleText = JSON.parse(exampleValue)
                  exampleText = JSON.stringify(exampleText).replaceAll('"', '\\"') // ex: createMember betLimit
                }
              } catch (e) {
                exampleText = renderJson ? exampleValue : `"${exampleValue}"`
              }
            }
          }
          break

        default:
          if (exampleValue) exampleText = renderJson ? exampleValue : `"${exampleValue}"`
          break
      }

      const docCurrency = props.docsDataByDocId[previewedState.docId]?.currency || '{{currency}}'
      if (typeof exampleText === 'string' && docCurrency) exampleText = exampleText.replaceAll('{{currency}}', docCurrency)
      return exampleText
    }

    const isEmptyExampleValue = (exampleValue, fieldType) => {
      if (exampleValue == null || exampleValue === '') return true
      if (typeof exampleValue === 'string' && /^\[\s*\]$/.test(exampleValue.trim())) return true
      if (Array.isArray(exampleValue) && !exampleValue.length) return true
      if (fieldType && STRING_ARRAY_TYPES.includes(fieldType)) {
        return Array.isArray(exampleValue) ? !exampleValue.length : /^\[\s*\]$/.test(String(exampleValue).trim())
      }
      return false
    }

    /** object / array of objects 僅在子欄位有實際 example 時才算有值 */
    const hasExampleValue = (fieldData, scope) => {
      const { fieldType, fieldId } = fieldData
      if (COMPLEX_FIELD_TYPES.includes(fieldType)) {
        return getChildFields(scope, fieldId).some(child => hasExampleValue(child, scope))
      }
      return !isEmptyExampleValue(fieldData?.examples?.[selectedExampleId.value], fieldType)
    }

    const checkFieldsHasExampleValue = (scope, fields) => {
      const fieldArr = Array.isArray(fields) ? fields : [fields]
      return fieldArr.some((fieldData) => {
        if (!fieldData) return false
        console.log(fieldData.fieldName, 'checkFieldsHasExampleValue fieldData', fieldData)
        return hasExampleValue(fieldData, scope)
      })
    }

    const renderExampleHtml = (scope, fieldData, arrayIdx) => {
      if (!shouldDisplay(fieldData, props.docsDataByDocId[previewedState.docId])) return ''

      let exampleTextClass = 'value'
      if (fieldData.fieldType === 'number') exampleTextClass = 'number'
      if (fieldData.fieldType === 'boolean') exampleTextClass = 'boolean'

      let exampleText = renderExampleValue(scope, fieldData, arrayIdx)
      if (exampleText === '\'\'' || exampleText === '""') console.log('+++++++++++exampleText', exampleText)

      if (fieldData.fieldType === 'array of objects') {
        let objHtml = ''
        const { arrayLength } = fieldData.examples?.[selectedExampleId.value] || {}

        Array.from({ length: arrayLength || 1 }).forEach((_, idx) => {
          const objFieldsHtml = getChildFields(scope, fieldData.fieldId).reduce((acc, childFieldData) => {
            const childExampleText = renderExampleHtml(scope, childFieldData, arrayLength != null ? idx : undefined)
            if (!childExampleText) return acc
            return acc.concat(childExampleText)
          }, []).join('<br>')

          if (!objFieldsHtml) return

          objHtml += `<div>
            <span class="punctuation">{</span>
              <div class="example-field" style="padding-left: 24px;">
              ${objFieldsHtml}
              </div>
            <span class="punctuation">},</span>
          </div>`
        })

        if (objHtml) {
          exampleText = `<span class="punctuation">[</span>
            <div class="example-field" style="padding-left: 24px;">
              ${objHtml}
            </div>
          <span class="punctuation">]</span>`
        }
      } else if (fieldData.fieldType === 'object') {
        const objFieldsHtml = getChildFields(scope, fieldData.fieldId).reduce((acc, childFieldData) => {
          const childExampleText = renderExampleHtml(scope, childFieldData)
          if (!childExampleText) return acc
          return acc.concat(childExampleText)
        }, []).join('<br>')

        if (objFieldsHtml) {
          const objHtml = `<span class="punctuation">{</span>
            <div class="example-field" style="padding-left: 24px;">
            ${objFieldsHtml}
            </div>
          <span class="punctuation">}</span>`

          exampleText = `<div class="example-field" style="padding-left: 24px;">
            ${objHtml}
          </div>`
        }
      }

      if (STRING_ARRAY_TYPES.includes(fieldData.fieldType)
        && exampleText
        && (!Array.isArray(exampleText) || exampleText.length)) {
        exampleText = `<span class="punctuation">[</span>
          ${exampleText.map(arrOfStr => `<div class="example-field" style="padding-left: 24px;">
            <span>${fieldData.fieldType === 'array of strings' ? `"${arrOfStr}"` : arrOfStr}</span><span class="punctuation">,</span>
          </div>`).join('')}
        <span class="punctuation">]</span>`
      }

      if (exampleText == null
        || exampleText === ''
        || (Array.isArray(exampleText) && !exampleText.length)) return ''

      return `<span class="property">"${fieldData.fieldName}": </span>
      <span class="${exampleTextClass}">${exampleText}</span><span class="punctuation">,</span>`
    }

    const isExampleDropdownVisible = ref(false)
    const toggleExampleDropdown = () => {
      isExampleDropdownVisible.value = !isExampleDropdownVisible.value
    }

    const handleSelectExample = (exampleId) => {
      selectedExampleId.value = exampleId
      isExampleDropdownVisible.value = false
    }

    return {
      isDev,
      isMasterSectionState,
      isDocCustomized,
      platformsMap,
      treeData,
      displayedTreeData,
      searchValue,
      platformInfoResetKey,
      selectedKeys,
      previewedState,
      renderFieldTableHtml,
      selectedExampleId,
      onSelect,
      renderExampleHtml,
      isExampleDropdownVisible,
      toggleExampleDropdown,
      getSortedExamples,
      handleSelectExample,
      checkFieldsHasExampleValue,
      getScopeRootFields,
      getDocSectionTreeData,
      getSectionsBySectionIdForDoc,
      contentHtml,
      restrictedContentHtml,
      tableDataHtml,
      fieldContentHtmls,
      titleCase,
    }
  },
}
</script>

<style scoped>
.apply-docs-col {
  height: 80vh;
  overflow-y: auto;
  padding: 16px;
  border-right: 1px solid #f0f0f0;
}

.apply-docs-col:last-of-type {
  border-right: none;
}

.preview-col {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}

.preview-header {
  flex-shrink: 0;
  padding: 16px 42px 16px 16px;
  border-bottom: 1px solid #eee;
}

.preview-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
}
</style>

<style lang="less">
.mock-redoc {
  display: flex;
  .examples code {
    .property {
      color: #fff;
    }
    .value {
      color: #a0fbaa;
    }
    .number {
      color: #4a8bb3;
    }
    .boolean {
      color: #e64441;
    }
    .punctuation {
      color: #fff;
      opacity: 0.7;
    }
  }

  .stringified-json-table p:first-child {
    margin-top: 0;
  }

  .nowrap {
    white-space: nowrap;
  }
  .content {
    width: 65%;
    padding: 20px;
    flex-grow: 1;
  }
  .api-content {
    table {
      width: 100%;
    }
    h3 {
      font-size: 1.3em;
      padding: 0.2em 0px;
      margin: 3em 0px 1.1em;
    }
    h5 {
      border-bottom: 1px solid rgba(38, 50, 56, 0.3);
      margin: 1em 0px;
      color: rgba(38, 50, 56, 0.5);
      font-weight: normal;
      text-transform: uppercase;
      font-size: 0.929em;
      line-height: 20px;
      span {
        margin-left: 10px;
        text-transform: none;
        font-size: 0.929em;
        color: black;
      }
    }
  }

  table {
    max-width: 100%;
  }

  tr:first-of-type > td.field-name {
    border-left-width: 0px;
    background-position: left top;
    background-repeat: no-repeat;
    background-size: 1px 100%;
    background-image: linear-gradient(transparent 0%, transparent 22px, rgb(175, 175, 175) 22px, rgb(175, 175, 175) 100%);
  }

  tr.last > td.field-name {
    border-left-width: 0px;
    background-position: left top;
    background-repeat: no-repeat;
    background-size: 1px 100%;
    background-image: linear-gradient(rgb(175, 175, 175) 0%, rgb(175, 175, 175) 22px, transparent 22px, transparent 100%);
  }

  td.field-name {
    width: 25%;
    color: #333;
    font-size: 12px;
    font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
    border-left: 1px solid #afafaf;
    position: relative;
    padding: 10px 10px 10px 0;
    vertical-align: top;
    line-height: 20px;
    white-space: nowrap;
    &.only {
      background: none!important;
      border-left-color: transparent;
    }
    .line {
      margin-right: 10px;
      &::before {
        content: "";
        display: inline-block;
        vertical-align: middle;
        width: 10px;
        height: 1px;
        background: #afafaf;
      }
      &::after {
        content: "";
        display: inline-block;
        vertical-align: middle;
        width: 1px;
        background: rgb(175, 175, 175);
        height: 7px;
      }
    }
  }

  td.field-content {
    width: 75%;
    border-bottom: 1px solid #9fb4be;
    padding: 10px 0px;
    &.has-nested {
      border-bottom: 0;
    }
    p:last-child {
      margin-bottom: 0;
    }
  }

  .required {
    color: #d41f1c;
    margin-left: 20px;
  }

  .field-type {
    color: #666666;
    vertical-align: middle;
    font-size: 12px;
    line-height: 20px;
    font-family: Roboto, sans-serif;
    code {
      background-color: rgba(190, 169, 160, 0.05);
      color: rgba(148, 115, 100, 0.9);
      margin: 0px 5px;
      border: 1px solid rgba(148, 115, 100, 0.1);
    }
  }

  code {
    background-color: rgba(51, 51, 51, 0.05);
  }

  .status-code-btn {
    display: block;
    border: 0px;
    width: 100%;
    text-align: left;
    padding: 10px;
    border-radius: 2px;
    margin-bottom: 4px;
    line-height: 1.5em;
    font-weight: bold;
    cursor: pointer;
    color: #1d8127;
    background-color: rgba(29, 129, 39, 0.07);
    svg {
      font-size: 12px;
    }
  }

  .stringified-json-table {
    display: block;
    width: 100%;
    overflow: auto;
    margin-top: 1.5em;
    margin-bottom: 1.5em;
    thead {
      font-weight: bold;
    }
    tr:nth-child(2n) {
      background-color: #fafafa;
    }
    td {
      border: 1px solid #ddd;
      padding: 6px 12px;
    }
  }

  .nested-table-wrapper {
    padding: 14px;
    margin: 14px 0px 14px 14px;
    background: #fafafa;
    .nested-table-wrapper {
      background: #fff;
    }
  }

  section.examples {
    font-size: 12px;
    padding: 40px;
    width: 35%;
    color: #ffffff;
    background-color: #303030;
    font-family: "Open Sans", Lato, Roboto, sans-serif;
    h3 {
      color: inherit;
      font-size: 16px;
      margin: 16px 0;
    }
    button {
      outline: 0px;
      width: 100%;
      padding: 10px 20px;
      border-radius: 4px 4px 0px 0px;
      background-color: #161616;
      display: flex;
      white-space: nowrap;
      align-items: center;
      text-align: left;
      border-width: 1px 1px 0px;
      border-top-style: solid;
      border-right-style: solid;
      border-left-style: solid;
      border-top-color: transparent;
      border-right-color: transparent;
      border-left-color: transparent;
      border-bottom-style: initial;
      border-bottom-color: initial;
      transition: border-color 0.25s;
    }
    .method {
      font-size: 11px;
      line-height: 20px;
      background-color: #186faf;
      color: rgb(255, 255, 255);
      padding: 3px 10px;
      text-transform: uppercase;
      font-family: "Open Sans", Lato, Roboto, sans-serif;
    }
    .path {
      font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
      margin-left: 10px;
      flex: 1 1 0%;
      overflow-x: hidden;
      text-overflow: ellipsis;
    }
    .example {
      color: #fff;
      padding: 20px;
      background-color: #161616;
      code {
        color: #fff;
      }
    }
    .example-input {
      position: relative;
      background-color: rgba(48, 48, 48, 0.4);
      padding: 11px 12px;
      margin-bottom: 16px;
    }
    .example-input-label {
      opacity: 0.7;
      position: absolute;
      z-index: 1;
      top: -11px;
      left: 12px;
      font-weight: 600;
    }
    .example-field {
      padding-left: 24px;
    }
    .example-dropdown-trigger {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .example-dropdown {
      position: absolute;
      margin-top: 2px;
      left: -2px;
      right: 0px;
      z-index: 10;
      min-width: 100px;
      background: white;
      border: 1px solid rgba(38, 50, 56, 0.2);
      border-radius: 4px;
      box-shadow: rgba(34, 36, 38, 0.12) 0px 2px 4px 0px, rgba(34, 36, 38, 0.08) 0px 2px 10px 0px;
      max-height: 220px;
      overflow: auto;
    }
    .example-dropdown-option {
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 5px;
      cursor: pointer;
      color: #263238;
      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }
    }
  }
}
</style>
